module.exports = __webpack_public_path__ + "img/INDUSTRIA_08.de954f6a.jpg";